(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advantage-block"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.pure-temp-glass-block').forEach(function(element) {
      element.addEventListener('click', function() {
        var target = this.getAttribute('data-target');
        var arrow = this.querySelector('.faq-arrow');
        var collapseContent = document.querySelector(target);
        
        // Toggle the rotate class and color
        arrow.classList.toggle('rotate');
        
        // Toggle collapse state
        if (collapseContent.classList.contains('show')) {
          collapseContent.classList.remove('show');
        } else {
          // Close other open FAQs
          document.querySelectorAll('.sand-glass-block.show').forEach(function(openContent) {
            openContent.classList.remove('show');
            var openArrow = document.querySelector(`[data-target="#${openContent.id}"] .faq-arrow`);
            if (openArrow) openArrow.classList.remove('rotate');
          });
          collapseContent.classList.add('show');
        }
      });
    });

    document.querySelectorAll('.wait-temp').forEach(function(element) {
      element.addEventListener('click', function() {
        var target = this.getAttribute('data-target');
        var collapseContent = document.querySelector(target);
        var arrow = document.querySelector(`[data-target="${target}"] .faq-arrow`);
        
        // Toggle the rotate class and color
        arrow.classList.toggle('rotate');
        
        // Toggle collapse state
        if (collapseContent.classList.contains('show')) {
          collapseContent.classList.remove('show');
        } else {
          // Close other open FAQs
          document.querySelectorAll('.sand-glass-block.show').forEach(function(openContent) {
            openContent.classList.remove('show');
            var openArrow = document.querySelector(`[data-target="#${openContent.id}"] .faq-arrow`);
            if (openArrow) openArrow.classList.remove('rotate');
          });
          collapseContent.classList.add('show');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-landing-page-main-banner"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const dropdownToggles = document.querySelectorAll(".dropdown-toggle");
  dropdownToggles.forEach(btn => {
    btn.addEventListener("click", function () {
      this.nextElementSibling.classList.toggle("show");
      this.classList.toggle("dropdown-style");
    });
  });

  const playBtn = document.querySelector(".playvideo-show-land");
  const iFrame = document.getElementById("iFrame3");
  const videoBg = document.querySelector(".video-background3");
  const closeBtn = document.querySelector(".close3");
  const youtubeVideo = document.getElementById("youtube-video3");

  const toggleVideo = (play) => {
    iFrame.classList.toggle("show");
    videoBg.classList.toggle("show");
    const command = play ? "playVideo" : "pauseVideo";
    youtubeVideo.contentWindow.postMessage(
      JSON.stringify({ event: "command", func: command, args: "" }),
      "*"
    );
  };

  playBtn?.addEventListener("click", () => toggleVideo(true));
  closeBtn?.addEventListener("click", () => toggleVideo(false));
  videoBg?.addEventListener("click", () => toggleVideo(false));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["play-button-video"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const playButtons = document.querySelectorAll('.playvideo-show');
  const closeButton = document.querySelector('.tabitha-close');
  const videoBackground = document.querySelector('.video-background');
  const iframe = document.getElementById('iFrame');
  const youtubeIframe = document.getElementById('youtube-video');

  playButtons.forEach(button => {
    button.addEventListener('click', function() {
      iframe.classList.toggle("show");
      videoBackground.classList.toggle('show');
      youtubeIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    });
  });

  closeButton.addEventListener('click', function() {
    iframe.classList.toggle("show");
    videoBackground.classList.toggle('show');
    youtubeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });

  videoBackground.addEventListener('click', function() {
    iframe.classList.toggle("show");
    videoBackground.classList.toggle('show');
    youtubeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-banner-dropdown"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const playButtons = document.querySelectorAll('.playvideo-show');
  const closeButton = document.querySelector('.tabitha-close');
  const videoBackground = document.querySelector('.video-background');
  const iframe = document.getElementById('iFrame');
  const youtubeIframe = document.getElementById('youtube-video');
  const deviceSelects = document.querySelectorAll('.device-select');

  playButtons.forEach(button => {
    button.addEventListener('click', function() {
      iframe.classList.toggle("show");
      videoBackground.classList.toggle('show');
      youtubeIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    });
  });

  closeButton.addEventListener('click', function() {
    iframe.classList.toggle("show");
    videoBackground.classList.toggle('show');
    youtubeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });

  videoBackground.addEventListener('click', function() {
    iframe.classList.toggle("show");
    videoBackground.classList.toggle('show');
    youtubeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });

  deviceSelects.forEach(select => {
    select.addEventListener('change', function() {
      const url = this.value;
      if (url) {
        window.location.href = url;
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-video-banner"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const playButtons = document.querySelectorAll('.playvideo-show');
  const closeButton = document.querySelector('.tabitha-close');
  const videoBackground = document.querySelector('.video-background');
  const iframe = document.getElementById('iFrame');
  const youtubeIframe = document.getElementById('youtube-video');

  playButtons.forEach(button => {
    button.addEventListener('click', function() {
      iframe.classList.toggle("show");
      videoBackground.classList.toggle('show');
      youtubeIframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
    });
  });

  closeButton.addEventListener('click', function() {
    iframe.classList.toggle("show");
    videoBackground.classList.toggle('show');
    youtubeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });

  videoBackground.addEventListener('click', function() {
    iframe.classList.toggle("show");
    videoBackground.classList.toggle('show');
    youtubeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });
});

  } catch(e) { console.error(e); }
})();
})();
